import { ISkillLevelResource } from "../../skill-levels";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillLevel } from "../types";

export type ISkillLevelQueryParameters = {
    skillLevel?: RelationalValue<ISkillLevelResource>;
};

export type ISkillLevelQueryResult = ISkillLevel;

export const skillLevelQuery: IApiQueryFunction<ISkillLevelQueryParameters> = ({ skillLevel }) => {
    if (!skillLevel) {
        return;
    }

    return {
        method: "GET",
        url: `/skill_levels/${mapRelationalValue(skillLevel)}`,
    };
};

export const useSkillLevelQuery = createApiQueryHook<ISkillLevelQueryParameters, ISkillLevelQueryResult>(
    skillLevelQuery,
);
